<bor-app-header />

<main class="site-main">
  <div class="text-center py-5 my-5 ">
    <h1 class="fw-bold heading-font text-success" style="font-size: 200px;">404</h1>
    <p class="fs-30 fw-bold heading-font">Page Not Found</p>
    <button class="btn btn-primary mt-4 fs-18 py-3 px-4" [routerLink]="'/'">
      Let's Take You Home
      <iconify [name]="'lucide:arrow-right'" />
    </button>
  </div>
</main>

<bor-app-footer />
